export default {
  c1: '優先Link號',
  c2: '搶占活動限定元宇宙身份ID開啟個人數字資產之旅',
  c3: '以上活動限定元宇宙身份ID已爲您準備好',
  c4: '立即領取',
  c5: '恭喜您 ！領取成功 ！',
  c6: '立即去換上新的元宇宙身份ID吧',
  c7: '去換號',
  c8: '溫馨提示',
  c9: '成功領取后的14天内可到元宇宙首頁按「新獲得」進入換號頁面換上此身份ID。如14天內沒有更換，此ID則會自動失效',
  c10: '選用此身份ID后還可自行將身份ID鑄造為NFT，享受更多權益',
  c11: '感謝您的參與！',
  c12: '您已領取過此號碼',
  c13: '查看我的Meta ID',
  c14: '溫馨提示',
  c15: '成功領取后的14天内可到元宇宙首頁按「新獲得」進入換號頁面換上此身份ID。如14天內沒有更換，此ID則會自動失效',
  c16: '選用此身份ID后還可自行將身份ID鑄造為NFT，享受更多權益',
  c17: '抱歉！',
  c18: '遇到網絡或不可預期的錯誤，請稍後刷新再試，謝謝。',
  c19: '好的',
  c20: '優先Link號！'
}
